import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import "./VisitUs.css";

const REGISTER_URL = `https://app.jackrabbitclass.com/regv2.asp?id=${process.env.REACT_APP_ORGID}`;

const VisitUs = () => (
  <section className="home-section" aria-labelledby="visit-heading">
    <div className="home-section__inner home-visit">
      <div className="home-visit__info">
        <header className="home-section__header">
          <h2 id="visit-heading" className="home-section__title">
            Visit Us
          </h2>
          <p className="home-section__subtitle">
            Come see our facility and meet our team. We would love to welcome
            your family to Ace Gymnastics.
          </p>
        </header>
        <address className="home-visit__address">
          <p>
            <a href="tel:502-252-8512" data-track="phone_click" data-track-location="home_visit">502-252-8512</a>
          </p>
          <p>
            <a
              href="mailto:office@ace-gymnastics.com"
              data-track="email_click"
              data-track-location="home_visit"
            >
              office@ace-gymnastics.com
            </a>
          </p>
          <p>2388 New Haven Road</p>
          <p>Bardstown, KY 40004</p>
        </address>
        <div className="home-visit__social">
          <span className="home-visit__social-label">Follow us</span>
          <a
            href="https://www.facebook.com/ACE-Gymnastics-101806134601903/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            data-track="social_click"
            data-track-location="home_visit"
            data-track-label="facebook"
          >
            <FontAwesomeIcon icon={faFacebookSquare} size="lg" />
          </a>
          <a
            href="https://www.instagram.com/ace.gymnastics/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-track="social_click"
            data-track-location="home_visit"
            data-track-label="instagram"
          >
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </a>
        </div>
        <div className="home-visit__actions">
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="home-btn home-btn--primary"
            data-track="register_click"
            data-track-location="home_visit"
          >
            Register Now
          </a>
          <Link
            to="/events"
            className="home-btn home-btn--outline"
            data-track="events_nav_click"
            data-track-location="home_visit"
          >
            View Events
          </Link>
        </div>
      </div>
      <div className="home-visit__map">
        <iframe
          title="Ace Gymnastics location on Google Maps"
          src="https://maps.google.com/maps?q=2388+New+Haven+Road+Bardstown+KY+40004&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  </section>
);

export default VisitUs;
